/**
 * Where a finding renders on its element's form. Each finding names the data field its rule
 * judges (`Finding.field`), which the backend sets beside the rule, so the rule-to-field map has
 * one home. A finding renders under its field, and in the element's Findings list, whose row
 * moves focus to that field.
 */
import type { Finding, FindingField } from '../types';

/** The findings that render under `field`. */
export function findingsAt(findings: Finding[], field: FindingField): Finding[] {
  return findings.filter((finding) => finding.field === field);
}

/** The DOM id of `field`'s container in the form `formId` names. */
export function findingAnchorId(formId: string, field: FindingField): string {
  return `${formId}-finding-${field}`;
}
